module.exports = __webpack_public_path__ + "static/media/cameraSwitch_lg.2095c04c.svg";